import React, {useState, useCallback, useEffect} from 'react';
import Dropdown from 'react-dropdown';
import {OCTAVE, CLOSEST} from 'constants/interpolation-modes.js';

export default function InterpolationDropdown(props) {
    const [value, setValue] = useState(undefined);
    const onChange = useCallback((o) => {
        props.instrument.interpolationMode = o.value;
        setValue(o.value);
    }, [props.instrument]);

    useEffect(() => {
        setValue(props.instrument.interpolationMode);
    }, []);

    return (
        <div className="interpolation-dropdown-container">
          <div className="label">
            Interpolation:
          </div>
          <Dropdown
            className='interpolation-dropdown'
            controlClassName='interpolation-control-dropdown'
            arrowClassName='interpolation-arrow-dropdown'
            options={OPTIONS}
            onChange={onChange}
            value={getOption(value)}
            placeholder="Interpolation" />
        </div>
    );
}

function getOption(value) {
    if (value === CLOSEST) {
        return {value: CLOSEST, label: 'Closest'};
    } else {
        return {value: OCTAVE, label: 'Octave'};
    }
}

const OPTIONS = [
    {value: CLOSEST, label: 'Closest'},
    {value: OCTAVE, label: 'Octave'},
];
